import React, { PureComponent } from 'react'
import moment from 'moment'
import styles from './PlaceComments.scss'
import Like from '@components/Like'
import Clap from './Clap'
import { compose } from '@hocs'

class PlaceCommentRow extends PureComponent {
  render() {
    const {
      comment: { id, userInfo, clap, text, t, like, currentUserLike },
      onClickedUser,
      onClickHeart,
      onClickRow,
    } = this.props
    return (
      <div key={id} className="comments__comment" onClick={onClickRow}>
        <style jsx>{styles}</style>
        <div onClick={onClickedUser}>
          <img
            className="comments__avatar"
            src={`https://static.popdaily.com.tw/${userInfo.img}`}
            alt=""
          />
        </div>
        <div className="comments__box">
          <div>
            <div onClick={onClickedUser} className="comments__authorName">
              <span>{userInfo.name}</span>
              <Clap clapNum={clap} />
            </div>
          </div>
          <div className="comments__content">{text}</div>
          <div className="comments__spaceBetween">
            <span className="comments__time">{moment(t).fromNow()}</span>
            <Like likeNum={like} isLike={currentUserLike} onClickLike={onClickHeart} />
          </div>
        </div>
      </div>
    )
  }
}

export default compose()(PlaceCommentRow)
